import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, Label, ModalHeader, Row } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import ReactTable from "react-table";
import JedaiTooltip from "../../coms/JedaiTooltip";
import Alerts from "../../util/Alerts";

export const TikTok = () => {
    const loginURL = routes.api + "/tiktok/authorization";
    const tokenURL = routes.api + "/tiktok/access-token";
    const idAdsURL = routes.api + "/tiktok/id-ad";
    const leadsURL = routes.api + "/tiktok/lead";
    const syncURL = routes.api + "/tiktok/load-lead";

    const [accessToken, setAccessToken] = useState("");
    const [listHeaders, setListHeaders] = useState([]);
    const [listAd, setListAd] = useState([]);
    const [listLeads, setListLeads] = useState([]);

    const alert = useRef(null);

    useEffect(() => {
        axios
            .get(tokenURL)
            .then(response => {
                setAccessToken(response.data.accessToken);
            })
            .catch(alert.current.handle_error);
    }, []);

    useEffect(() => {
        axios
            .get(idAdsURL)
            .then(response => {
                setListAd(response.data);
                console.log(response);
            })
            .catch(alert.current.handle_error);
    }, []);

    useEffect(() => {
        buildLeadsHeader(listLeads[0]);
    }, [listLeads]);

    const syncTiktok = () => {
        axios
            .get(syncURL)
            .then(() => {
                alert.current.show_info("Sincronizado con éxito");
            })
            .catch(alert.current.handle_error);
    };

    const getLeads = e => {
        const idAd = e.target.value;
        if (idAd !== "0") {
            axios
                .get(leadsURL, { params: { idAd: idAd } })
                .then(({ data }) => {
                    data.forEach(item => {
                        item.infoLead = JSON.parse(item.infoLead);
                    });
                    setListLeads(data);
                })
                .catch(alert.current.handle_error);
        }
    };

    const buildLeadsHeader = lead => {
        lead && setListHeaders(Object.keys(lead));
    };

    const tooltip = (data, infoData) => {
        return (
            <span>
                <JedaiTooltip placement={"bottom"} message={tooltipMessage(infoData)}>
                    <Button color="primary">{data}</Button>
                </JedaiTooltip>
            </span>
        );
    };

    function tooltipMessage(infoData) {
        let infoKeys = Object.keys(infoData);
        return (
            <div className="text-left">
                {infoKeys.map(item => (
                    <React.Fragment key={item}>
                        <strong>{item}</strong>
                        <span> {infoData[item]}</span>
                        <br />
                    </React.Fragment>
                ))}
            </div>
        );
    }

    function cellContent(row, key) {
        if (key === "infoLead") {
            return tooltip("Registro", row.value);
        }
        return <p>{row.value}</p>;
    }

    return (
        <>
            <Alerts ref={alert} />
            <div className="content">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <a href={loginURL} className="btn btn-primary">
                                    Conectar con TikTok
                                </a>
                            </CardBody>
                            <Container>
                                <ModalHeader className="text-center">Tokens</ModalHeader>
                                <CardBody>
                                    <Row>
                                        <span className="text-center">
                                            <strong>Token de acceso: </strong>
                                            {accessToken}
                                        </span>
                                    </Row>
                                </CardBody>
                            </Container>
                            <CardBody>
                                <Button onClick={syncTiktok} color="primary">
                                    Sincronización con TikTok
                                </Button>
                            </CardBody>
                            <Container>
                                <ModalHeader className="text-center">Leads de TikTok</ModalHeader>
                                <CardBody>
                                    <div className="form-group col-lg-6">
                                        <Label>Campañas:</Label>
                                    </div>
                                    <Row className="my-3">
                                        <Col>
                                            <select className="form-control primary" onChange={getLeads}>
                                                <option value="0">-- SELECCIONE --</option>
                                                {listAd.map(item => (
                                                    <option key={item.ad_id} value={item.ad_id}>
                                                        {item.ad_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <ReactTable
                                            className="w-100 h-75"
                                            noDataText={"No hay datos..."}
                                            loadingText={"Cargando..."}
                                            rowsText={"filas"}
                                            ofText={"de"}
                                            previousText={"Anterior"}
                                            nextText={"Siguiente"}
                                            pageText={"Página"}
                                            columns={listHeaders.map(key => ({
                                                Header: key.toLocaleUpperCase(),
                                                accessor: key,
                                                Cell: row => cellContent(row, key),
                                                width: 200,
                                                minWidth: 100,
                                            }))}
                                            data={listLeads}
                                        ></ReactTable>
                                    </Row>
                                </CardBody>
                            </Container>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};
